"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorLinkComponent = exports.AnchorComponent = void 0;
var AnchorComponent_1 = require("./AnchorComponent");
Object.defineProperty(exports, "AnchorComponent", { enumerable: true, get: function () { return AnchorComponent_1.AnchorComponent; } });
var AnchorLinkComponent_1 = require("./AnchorLinkComponent");
Object.defineProperty(exports, "AnchorLinkComponent", { enumerable: true, get: function () { return AnchorLinkComponent_1.AnchorLinkComponent; } });
